import { render } from "./InvestmentPerformance.vue?vue&type=template&id=0e9cace7&scoped=true"
import script from "./InvestmentPerformance.vue?vue&type=script&lang=js"
export * from "./InvestmentPerformance.vue?vue&type=script&lang=js"

import "./InvestmentPerformance.vue?vue&type=style&index=0&id=0e9cace7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9cace7"]])

export default __exports__